import { FC } from 'react';
import styled from 'styled-components';
import { Button } from '@algoan/deep-dive/button';
import { ComponentProps } from '@algoan/deep-dive/model';
import { defineMessages, useIntl } from 'react-intl';
import { Error } from '@algoan/deep-dive/error';
import { Body } from '@algoan/deep-dive/fonts';

export interface TechnicalErrorProps extends ComponentProps {
  /** Action to run when the button is pressed */
  onButtonClick: () => void;
}

export const technicalErrorMessages = defineMessages({
  description: {
    id: 'technical_error_page.description',
    defaultMessage:
      'You have been disconnected from our services due\u000ato a technical issue. We invite you to log in again.',
    description: 'Description of the page',
  },
  button: {
    id: 'technical_error_page.button',
    defaultMessage: 'Log in',
    description: 'Lable of the button',
  },
  link: {
    id: 'technical_error_page.link',
    defaultMessage: 'Contact support',
    description: 'Lable of the link',
  },
});

export const TechnicalError: FC<TechnicalErrorProps> = ({ className, 'data-testid': dataTestId, onButtonClick }) => {
  const intl = useIntl();

  return (
    <Error
      className={className}
      data-testid={dataTestId}
      buttons={
        <S.Buttons>
          <S.Button variant="main" onClick={onButtonClick}>
            {intl.formatMessage(technicalErrorMessages.button)}
          </S.Button>
          <S.Link href="https://algoan.zendesk.com/" target="_blank">
            {intl.formatMessage(technicalErrorMessages.link)}
          </S.Link>
        </S.Buttons>
      }
      subTitle={<Body>{intl.formatMessage(technicalErrorMessages.description)}</Body>}
    />
  );
};

const S = {
  Buttons: styled.div`
    display: flex;
    gap: 50px;
    align-items: center;
  `,
  Link: styled.a`
    color: ${({ theme }) => theme.bluePeps};
    font-size: 17px;
    font-weight: 400;
    line-height: 21px;
    text-decoration: none;
    white-space: nowrap;
  `,
  Button: styled(Button)`
    padding: 0 64px;
    white-space: nowrap;
  `,
};
